import axios, { AxiosRequestConfig } from "axios";

import { Storage } from "@/services/interfaces/enums";
import { personalModule } from "@/plugins/store-accessors";

const refreshUrl = location.origin + `/api/auth/refresh`;

axios.interceptors.request.use((request: AxiosRequestConfig) => {
  const token = localStorage.getItem(Storage.TOKEN);
  if (token) request.headers.Authorization = "Bearer " + token;
  // console.log("current User", personalModule.getUser);
  return request;
});

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const originRequest = error.config;
    const refresh = localStorage.getItem(Storage.REFRESH_TOKEN);
    // console.log("catch error", error, error.message);
    if (
      !error.response ||
      error.response.status !== 401 ||
      originRequest.url === refreshUrl ||
      !refresh
    ) {
      // console.log("reject refresh", error.message, originRequest.url);
      return Promise.reject(error);
    }

    // console.log("send refresh");
    const refreshRequest = {
      url: refreshUrl,
      method: "POST",
      data: { refresh },
    } as AxiosRequestConfig;

    return axios(refreshRequest)
      .then(response => {
        const newToken = response.data.data.token;
        const newRefresh = response.data.data.refresh;
        if (newToken && newRefresh) {
          localStorage.setItem(Storage.TOKEN, newToken);
          localStorage.setItem(Storage.REFRESH_TOKEN, newRefresh);
          axios.defaults.headers.common["Authorization"] = "Bearer " + newToken;
        }
        // console.log("refresh success");
        return axios(originRequest);
      })
      .catch(() => {
        personalModule.forceLogout();
        const tokenError = new Error("Cannot refresh token");
        // console.warn("catch refresh error", tokenError, tokenError.message);
        return Promise.reject(tokenError);
      });
  },
);

export default axios;
